import React from "react";

class AsideSubTitle extends React.Component {
  render() {
    return <p className="card-text text-center mb-1">{this.props.text}</p>;
  }
}

export default AsideSubTitle;
